import React  from "react";
import { connect } from 'react-redux';

function SamplePayload(props) {
    return (
        <div>
            <div className="sample_payload">
                1. Select post request,paste the url({window._env.REACT_APP_EMCONSOLE_API_URL}/v1/queue).<br></br>
                2. Form the Payload.<br></br>
                    For Ex:<br></br>
                        &#123;<br></br>
                            "uname":"{props.user.email}",<br></br>
                            "pwd":"Your Password",<br></br>
                            "bot_id":{props.bot.id},<br></br>
                            "worker_id":{props.workers},<br></br>
                            "params":"",<br></br>
                            "execution_type":"chrome",<br></br>
                            "channel":"web"<br></br> 
                        <span className="rotate">&#125;</span>      
                <button className="btn" style={{marginLeft:"180px"}}
                    onClick={() => props.toggle()}>
                    cancel
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(SamplePayload);
